/**
 * Returns a URL with query string and hash removed so identity params
 * (tenantId, customerName, linkId, etc.) never land in Datadog RUM.
 */
export function toPathOnlyUrl(url: string): string {
  if (!url) {
    return url;
  }

  try {
    if (/^[a-zA-Z][a-zA-Z\d+\-.]*:\/\//.test(url)) {
      const parsed = new URL(url);
      parsed.search = "";
      parsed.hash = "";
      return parsed.toString();
    }

    if (url.startsWith("//")) {
      const parsed = new URL(`https:${url}`);
      parsed.search = "";
      parsed.hash = "";
      return `//${parsed.host}${parsed.pathname}`;
    }

    const cut = url.search(/[?#]/);
    return cut === -1 ? url : url.slice(0, cut);
  } catch {
    const cut = url.search(/[?#]/);
    return cut === -1 ? url : url.slice(0, cut);
  }
}
